import { type FormEventHandler, useCallback, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import useDebounce from "@/lib/hooks/use-debounce";
import { useLocalStorage } from "@/lib/hooks/use-local-storage";
import { sendTelemetryEvent } from "@/lib/telemetry";
import { searchHistoryKey, searchQueryParam } from "@Constants/PortalConstants";

export function useOnSearchFormSubmit() {
    const navigate = useNavigate();
    const { value: historyList, update: setHistoryList } = useLocalStorage<Array<string>>(
        searchHistoryKey,
        [],
    );

    return useCallback<FormEventHandler<HTMLFormElement>>(
        (event) => {
            event.preventDefault();
            const input = ((event.target as HTMLFormElement)[0] as HTMLInputElement).value;
            if (input) {
                const h = historyList.filter((h) => h !== input);
                h.unshift(input);

                setHistoryList(h.slice(0, 3));

                sendTelemetryEvent({
                    eventName: "search-searchEdit",
                    param1: input,
                    actionType: "Click",
                });

                const searchParams = new URLSearchParams();
                searchParams.set(searchQueryParam, input);
                navigate("/szukaj?" + searchParams.toString());
            }
        },
        [historyList, setHistoryList],
    );
}

export function useOnSearchInputChange() {
    const [searchParams] = useSearchParams();
    const initialSearch = searchParams.get("search") || "";
    const inputRef = useRef<HTMLInputElement>(null);
    const [searchText, setSearchText] = useState(initialSearch.substring(0, 1000));

    const inputValue = useDebounce(searchText, 500);

    return { inputValue, setSearchText, inputRef, searchText };
}
